/** Inline markdown → HTML (Al Muslim Books / announcements parity). Safe for dangerouslySetInnerHTML after escaping base. */

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function escapeHtmlAttribute(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function isSafeUrl(href: string): boolean {
  const t = href.trim().toLowerCase();
  return (
    t.startsWith('https://') ||
    t.startsWith('http://') ||
    t.startsWith('mailto:') ||
    (t.startsWith('/') && !t.startsWith('//'))
  );
}

export function inlineMarkdownToHtml(src: string): string {
  const input = src || '';
  const chunks = input.split(/(`[^`]*`)/g);
  const out: string[] = [];
  for (let i = 0; i < chunks.length; i++) {
    const part = chunks[i];
    if (part.startsWith('`') && part.endsWith('`') && part.length >= 2) {
      out.push('<code>' + escapeHtml(part.slice(1, -1)) + '</code>');
      continue;
    }
    let s = escapeHtml(part);
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_m, label: string, href: string) => {
      if (!isSafeUrl(href)) return escapeHtml('[' + label + '](' + href + ')');
      return (
        '<a href="' +
        escapeHtmlAttribute(href) +
        '" rel="noopener noreferrer">' +
        escapeHtml(label) +
        '</a>'
      );
    });
    s = s.replace(/\n/g, '<br>');
    out.push(s);
  }
  return out.join('');
}

export function parseMarkdownTable(text: string): string | null {
  const lines = text
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);
  if (lines.length < 2) return null;
  const splitRow = (line: string) => {
    let t = line.trim();
    if (t.startsWith('|')) t = t.slice(1);
    if (t.endsWith('|')) t = t.slice(0, -1);
    return t.split('|').map((c) => c.trim());
  };
  const header = splitRow(lines[0]);
  if (header.length < 2) return null;
  const sepCells = splitRow(lines[1]);
  if (sepCells.length < 2) return null;
  const okSep = sepCells.every((c) => /^:?-{3,}:?$/.test(c.replace(/\s/g, '')));
  if (!okSep) return null;
  const bodyLines = lines.slice(2);
  let html =
    '<table class="wi-books-table"><thead><tr>' +
    header.map((h) => '<th>' + escapeHtml(h) + '</th>').join('') +
    '</tr></thead><tbody>';
  for (const row of bodyLines) {
    const cells = splitRow(row);
    if (!cells.length) continue;
    html += '<tr>' + cells.map((c) => '<td>' + escapeHtml(c) + '</td>').join('') + '</tr>';
  }
  html += '</tbody></table>';
  return html;
}

export function youtubeVideoId(url: string): string | null {
  const u = url.trim();
  let m = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
  if (m) return m[1];
  m = u.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/);
  return m ? m[1] : null;
}

export function vimeoVideoId(url: string): string | null {
  const m = url.trim().match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}
